<script>
import {useStore} from "vuex";
import {ref} from "vue";
import FreeWorld from "@/assets/js/FreeWorld";
import $ from "jquery";
import BottomNavigation from "@/components/assetComponents/BottomNavigation.vue";
import Swals from "@/assets/js/Swals";
import router from "@/router";

export default {
  name: "CategoryAdvertising",
  components: {BottomNavigation},
  setup(){
    let store = useStore()
    let category = ref(FreeWorld.PinkMan(store.state.category, 'de'))
    let car_category = ref([])

    let data = {
      adver_category_id: null,
    }
    let show_data = ref({
      adver_category: null,
      car: null,
    })

    function open_category(id) {
      let div = document.getElementById("parent-item" + id);
      let img = $("#img_parent" + id)

      for (let x = 1 ; x <= 2 ; x++){
        if (x !== id) {
          document.getElementById("parent-item" + x).style.height = '4rem'
          $("#img_parent" + x).removeClass('rotate')
        }
      }

      let heightInRem = div.scrollHeight

      if (div.style.height === heightInRem + 'px') {
        div.style.height = '4rem';
        img.removeClass('rotate')
      } else {
        div.style.height = heightInRem + 'px';
        img.addClass('rotate')
      }
    }
    function chang_item(type, id) {
      switch (type) {
        case 'category':
          category.value.forEach((item) => {
            if (item.id === id) {
              show_data.value.adver_category = item.name
              car_category.value = item.cat
              return false
            }
          })
          show_data.value.car = null
          data.adver_category_id = null
          open_category(1)
          break;

        case 'sub_category':
          car_category.value.forEach((item) => {
            if (item.id === id) {
              data.adver_category_id = item.id
              show_data.value.car = item.name
              return false
            }
          })
          open_category(2)
          break;
      }
    }
    function next_page() {
      if (show_data.value.adver_category === null) {Swals.Warning('لطفا دسته بندی خودرو را انتخاب کنید!');return false}
      if (data.adver_category_id === null) {Swals.Warning('لطفا نوع خودرو را انتخاب کنید!');return false}

      router.push({name:'AdvertisingPage' , params:{cat_id: data.adver_category_id}})
    }

    store.commit('set_filter_advertising', 'delete');

    return{
      category,
      car_category,
      show_data,
      chang_item,
      open_category,
      next_page,
    }
  }
}
</script>

<template>

  <div id="main" class="bg-color-liner">
    <div style="height: 5rem" class="p-4">
      <div class="d-flex">
        <img onclick="window.history.back()" class="icon-size-1 rounded-pill ms-3" src="../assets/img/icon-back.svg" alt="">
        <p class="text-white font-bold font-4">ثبت آگهی</p>
      </div>
    </div>

    <div id="chile-main" class="bg-main rounded-top-5 p-3 pt-4">
      <div id="parent-item1" class="parent-item p-3 bg-custom rounded-4 overflow-hidden mb-3 shadow-custom">
        <div @click="open_category(1)" class="d-flex justify-content-between mb-4">
          <p class="font-4 text-color">دسته بندی</p>

          <div class="d-flex align-items-center">
            <p v-if="show_data.adver_category !== null" class="font-5 text-color ms-3">{{ show_data.adver_category }}</p>

            <img id="img_parent1" class="icon-size-3 transition" src="../assets/img/icon-flash.svg" alt="">
          </div>
        </div>

        <div class="child_item py-3 px-5 shadow-custom rounded-4">
          <div v-for="item in category" :key="item.id" @click="chang_item('category' , item.id)" class="">
            <p class="font-4 text-color text-center font-4">{{ item.name }}</p>
            <hr>
          </div>
        </div>
      </div>

      <div id="parent-item2" class="parent-item p-3 bg-custom rounded-4 overflow-hidden mb-3 shadow-custom">
        <div @click="open_category(2)" class="d-flex justify-content-between mb-4">
          <p class="font-4 text-color">انتخاب نوع</p>

          <div class="d-flex align-items-center">
            <p v-if="show_data.car !== null" class="font-5 text-color ms-3">{{ show_data.car }}</p>

            <img id="img_parent2" class="icon-size-3 transition" src="../assets/img/icon-flash.svg" alt="">
          </div>
        </div>

        <div class="child_item py-3 px-5 shadow-custom rounded-4">
          <div v-for="item in car_category" :key="item.id" @click="chang_item('sub_category' , item.id)" class="">
            <p class="font-4 text-color text-center font-4">{{ item.name }}</p>
            <hr>
          </div>
        </div>
      </div>

      <div class="d-flex justify-content-center mt-5">
        <p @click="next_page" class="rounded-pill w-35 bg-color text-center text-white font-bold p-3 font-4 shadow-custom">بعدی</p>
      </div>

      <BottomNavigation></BottomNavigation>
    </div>
  </div>

</template>

<style scoped>
.parent-item {
  height: 4rem;
  transition: .5s;
}
.child_item {
  max-height: 20rem;
  overflow-y: scroll;
}
.rotate{
  transform: rotate(180deg);
}
.transition{
  transition: .5s;
}
</style>